import { queryKeys } from '@/lib/query-keys';
import { orgMembersClient } from '@/lib/api/ts-rest';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpdateMemberAllowedSites() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      organizationId,
      userId,
      siteIds,
    }: {
      organizationId: string;
      userId: string;
      siteIds: string[];
    }) => {
      const res = await orgMembersClient.updateMemberAllowedSites({
        params: { organizationId, memberId: userId },
        body: { siteIds },
      });
      if (res.status !== 200) throw new Error('Failed to update sites');
      return res.body;
    },
    onSettled: (_data, _error, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.organizations.memberAllowedSites(
          variables.organizationId,
          variables.userId,
        ),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.organizations.current(),
      });
    },
  });
}
